import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Timeline from "@/components/Timeline";

export default function PatientTimeline() {
  const [events, setEvents] = useState(null);
  useEffect(() => { api.get("/patient/timeline").then((r) => setEvents(r.data.timeline)).catch(() => setEvents([])); }, []);

  return (
    <div className="space-y-6" data-testid="patient-timeline">
      <div>
        <h1 className="font-heading text-2xl font-bold tracking-tight">My Journey</h1>
        <p className="text-sm text-muted-foreground mt-1">Everything in your care, in one place.</p>
      </div>
      <div className="bg-card border border-border rounded-xl p-6">
        {events === null ? <p className="text-sm text-muted-foreground">Loading…</p> : <Timeline events={events} testid="patient-timeline-list" />}
      </div>
    </div>
  );
}
